{
    "CONFIRM": "Confirmación",
    "SURE": "¿Está seguro de que desea salir de la pantalla?",

    "CANCEL": "Cancelar",
    "YES": "Sí"
}